import { render, staticRenderFns } from "./MyeDocuments.vue?vue&type=template&id=22dddd25&scoped=true"
import script from "./MyeDocuments.vue?vue&type=script&lang=js"
export * from "./MyeDocuments.vue?vue&type=script&lang=js"
import style0 from "./MyeDocuments.vue?vue&type=style&index=0&id=22dddd25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dddd25",
  null
  
)

export default component.exports